<template>
    <div class="container-fluid p-0">
    <nav 
        :class="[
            'navbar', 
            'navbar-expand-lg',
            'navbar-fixed-top',
            'navbar-dark',
            'bg-dark',
            'page-margin',
            'p-0',
            'rounded-bottom'
        ]"
    >
        <a class="navbar-brand p-0 m-0">
            <router-link to="/painel" class="navbar-brand-link">
                <img 
                    id="nav-bar-logo"
                    src="@/assets/compressed/card.png" 
                    alt="Logo"
                    class="img-fluid"
                >
            </router-link>
        </a>
        <button
        class="navbar-toggler"
        type="button"
        :aria-expanded="isMenuOpen"
        aria-controls="dashboardNavbarContent"
        aria-label="Abrir ou fechar menu"
        @click="isMenuOpen = !isMenuOpen"
        >
        <span class="navbar-toggler-icon"></span>
        </button>
        <div
        id="dashboardNavbarContent"
        class="collapse navbar-collapse"
        :class="{ show: isMenuOpen }"
        >
        <ul class="navbar-nav mx-auto">
        <li>
            <router-link
                to="/painel"
                class="nav-link font-roboto"
                active-class="active"
                aria-current="page"
                :title="`Voltar ao Início`"
                @click="closeMenu"
            >
                Início
            </router-link>
            </li>
            <li>
                <router-link
                    to="/operacoes"
                    class="nav-link font-roboto"
                    active-class="active"
                    aria-current="page"
                    :title="`Cadastre operações financeiras`"
                    @click="closeMenu"
                >
                    Operações
                </router-link>
            </li>
            <li v-if="isOwner()" class="nav-item dropdown">
                <a 
                    class="nav-link dropdown-toggle font-roboto" 
                    href="#" 
                    id="navbarDropdown2" 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                >
                    Controladoria
                </a>
                <ul class="dropdown-menu m-0 p-0" aria-labelledby="navbarDropdown2">
                    <li>
                        <router-link
                            to="/controladoria-mensal"
                            class="dropdown-item"
                            active-class="active"
                            :title="`Painel de controladoria por mês`"
                            @click="closeMenu"
                        >
                            Mensal
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/controladoria-anual" 
                            class="dropdown-item"
                            :title="`Painel de controladoria por ano`"
                            active-class="active"
                            @click="closeMenu"
                        >
                            Anual
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/controladoria"
                            class="dropdown-item"
                            active-class="active"
                            :title="`Novo painel de controladoria`"
                            @click="closeMenu"
                        >
                            Novo
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="nav-item dropdown" v-if="isOwner()">
                <a 
                    class="nav-link dropdown-toggle font-roboto" 
                    href="#" 
                    id="navbarDropdown" 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                >
                    Gerenciar
                </a>
                <ul class="dropdown-menu m-0 p-0" aria-labelledby="navbarDropdown">
                    <li v-if="isAdmin()">
                        <router-link 
                            to="/editar-rede" 
                            class="dropdown-item"
                            :title="`Cadastre, edite ou exclua redes`"
                            active-class="active"
                            @click="closeMenu"
                        >
                            Redes
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/editar-loja" 
                            class="dropdown-item"
                            :title="`Cadastre, edite ou exclua lojas`"
                            active-class="active"
                            @click="closeMenu"
                        >
                            Lojas
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/editar-operador" 
                            class="dropdown-item"
                            :title="`Cadastre, edite ou exclua operadores`"
                            active-class="active"
                            @click="closeMenu"
                        >
                            Operadores
                        </router-link>
                    </li>
                    <li v-if="isAdmin()">
                        <router-link 
                            to="/parametros" 
                            class="dropdown-item"
                            :title="`Edite os parâmetros do sistema`"
                            active-class="active"
                            @click="closeMenu"
                        >
                            Parâmetros
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/relatorio-login"
                            class="dropdown-item"
                            :title="`Relatório de acessos`"
                            active-class="active"
                            @click="closeMenu"
                        >
                            Relatório de Login
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <form class="d-flex ms-1 dashboard-navbar-actions">
            <button
                type="button"
                class="btn btn-primary light-text" 
                @click.prevent="goToAccount"
            >
            <i class="bi bi-person-circle"></i> <span>&nbsp;</span> Conta
            </button>
            <button
                type="button"
                class="btn btn-primary light-text" 
                @click.prevent="goToFAQ"
            >
            <i class="bi bi-question-circle"></i> <span>&nbsp;</span> Ajuda
            </button>
            <button
                type="button"
                class="btn btn-primary light-text btn-logout" 
                @click.prevent="logout"
            >
            <i class="bi bi-box-arrow-right"></i> <span>&nbsp;</span> Sair
            </button>
        </form>
        </div>
    </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pages: [],
            isMenuOpen: false
        };
    },
    methods: {
        closeMenu() {
            this.isMenuOpen = false;
        },
        goToAccount() {
            this.closeMenu();
            this.$router.push('/conta');
        },
        goToFAQ() {
            this.closeMenu();
            this.$router.push('/faq');
        },
        logout() {
            this.closeMenu();
            this.$axios.get('/api/logout')
                .then(() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.dispatchEvent(new CustomEvent('isLoggedInChanged', { detail: false }));
                    this.$router.push('/login');
                })
                .catch(() => {
                    // If the server is down, the user is logged out anyway
                    
                    localStorage.clear();
                    sessionStorage.clear();
                    window.dispatchEvent(new CustomEvent('isLoggedInChanged', { detail: false }));
                    this.$router.push('/login');
                });
        },
        isAdmin() {
            return localStorage.getItem('role') === 'administrador';
        },
        isOwner() {
            return localStorage.getItem('role') === 'donorede' || localStorage.getItem('role') === 'administrador';
        }
    }
}
</script>

<style scoped>
.navbar {
    background-color: #42413f !important;
}
.navbar-brand { 
    width: 180px; /* "Conserta" centralização dos itens */
}

ul.navbar-nav {
    gap: 20px;
    font-weight: bold;
}

ul.navbar-nav li a {
    border-radius: 5px;
}
ul.navbar-nav li a:hover {
    background-color: #5a5a5a; /* Cor ligeiramente mais clara */
}

button.btn-primary {
    width: 100px;
    margin-right: 10px;
    font-weight: bold;
    background-color: #003867;
    border-color: #003867;
}
button.btn-primary:hover{
    background-color: #ffd700;
    border-color: #ffd700;
}

button.btn-logout {
    background-color: #ff0000;
    border-color: #ff0000;
}

button.btn-logout:hover {
    color: #ff0000;
    background-color: white;
    border-color: white;
}

.dropdown-item:hover {
    background-color: #003867 !important;
    color: white;
}

@media (max-width: 991.98px) {
    .navbar.page-margin {
        align-items: center;
        margin-left: 0;
        margin-right: 0;
        padding: 0.5rem 0.75rem !important;
    }

    .navbar-brand {
        width: auto;
        max-width: calc(100% - 56px);
    }

    #nav-bar-logo {
        max-height: 48px;
        width: auto;
    }

    .navbar-collapse {
        flex-basis: 100%;
        padding-top: 0.5rem;
    }

    ul.navbar-nav {
        gap: 0;
    }

    .dashboard-navbar-actions {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.5rem;
        margin: 0.5rem 0 0;
    }

    .dashboard-navbar-actions button.btn-primary {
        width: 100%;
        margin: 0;
        padding: 0.375rem 0.25rem;
        font-size: 0.875rem;
    }
}
</style>